import type { FC } from 'react';

import { HelpChapterProps } from '../../../../api/fetchers/help/fetcher';
import { HelpText } from '../../utils/HelpText';

export const HelpChapterGameInconveniences: FC<HelpChapterProps> = ({ content }) => {
  if (!content) return null;

  return (
    <div>
      <p>
        <HelpText>{String(content.gameError)}</HelpText>
      </p>
      <p>
        <HelpText>{String(content.errorSolved)}</HelpText>
      </p>
      <p>
        <HelpText>{String(content.errorGameID)}</HelpText>
      </p>
    </div>
  );
};
